"use client";

import { Link } from "react-router-dom";

import { Button, Card } from "@/components/ui-system";
import { useDashboardBuilder } from "@/contexts/DashboardBuilderContext";

export function DashboardEmptyState() {
  const { setEditMode, setAddModalOpen } = useDashboardBuilder();

  return (
    <Card className="flex flex-col items-center justify-center gap-ds-4 border-dashed border-border-strong/40 bg-muted-bg/20 p-ds-10 text-center">
      <p className="text-title text-foreground">No widgets yet</p>
      <p className="max-w-md text-caption text-muted">
        Add widgets to this dashboard to see live telemetry. Each widget binds to a device channel using the standard
        config shape.
      </p>
      <div className="flex flex-wrap justify-center gap-ds-2">
        <Button
          type="button"
          variant="primary"
          size="sm"
          onClick={() => {
            setEditMode(true);
            setAddModalOpen(true);
          }}
        >
          Add widget
        </Button>
        <Link to="/dashboards" className="btn btn-secondary btn-sm !no-underline">
          Open dashboards
        </Link>
      </div>
    </Card>
  );
}
